import { EcheqTransaction as TransactionCardHOC } from "./EcheqTransactionContext";
import { EcheqTransactionHeader } from "./EcheqTransactionHeader";
import { EcheqTransactionSign } from "./EcheqTransactionSign";

export { EcheqTransactionHeader } from "./EcheqTransactionHeader";
export { EcheqTransactionSign } from "./EcheqTransactionSign";
export { EcheqTransactionInfo } from "./EcheqTransactionInfo";

export const EcheqTransactionCard = Object.assign(TransactionCardHOC, {
    Header: EcheqTransactionHeader,
    Sign: EcheqTransactionSign,
});

export default EcheqTransactionCard;
